<div class="time-dropdown" [class.error]="hasError()">
  <dojo-button [fill]="'outline'" [size]="size()" [matMenuTriggerFor]="timeMenu" class="time-button">
    <dojo-icon icon="clock" [size]="14" class="mr-2" />
    <span class="text-primary font-medium">
      {{ control().value ? control().value : placeholder() }}
    </span>
    <dojo-icon icon="angle-down" [size]="14" class="ml-1.5" />
  </dojo-button>

  <mat-menu #timeMenu="matMenu" class="time-picker-menu">
    @for (time of timeOptions; track time) {
      <button mat-menu-item [class.selected]="control().value === time" (click)="selectTime(time)">
        {{ time }}
      </button>
    }
  </mat-menu>
</div>
